import { Communication } from './course-communication';
import { MinimalActivity, ActivityType, ActivityProgress } from './activity';
import { PointsConfiguration } from './points-configuration';
import { MinimalCourse } from './course';
import { User } from './my-account';
import { Normalized } from '../normalized';

export interface InPersonEventSessionNormalized { [id: string]: InPersonEventSession }

/**
 * Minimal In-Person Event Activity for references
 */
export interface MinimalInPersonEventActivity extends MinimalActivity {
  type: ActivityType.IN_PERSON_EVENT;
  activityType: string;
  course: MinimalCourse;
  lectureComponentId?: number;
  lecturePageId?: number;
  releaseDate?: string;
}

export enum AttendeeInfoStatus {
  NOT_AVAILABLE = 'not_available',
  IS_CONFIRMED = 'is_confirmed',
  CHECK_IN_MANUAL = 'check_in_manually',
  MISSED = 'missed',
  CHECK_IN_QR_CODE = 'check_in_qr_code',
  COMPLETED = 'completed',
}

export interface InPersonEventSession {
  id: number;
  title: string;
  description: string;
  startTime: string;
  endTime: string;
  location: string;
  timeZone: string;
  ownerId: number;
  ownerType: string;
  confirmedRegistration: number;
  qrCodeUrl?: string;
  status: AttendeeInfoStatus;
}

export type TimelineInPersonEvent = {
  id: number;
  title: string;
  pointsConfiguration: PointsConfiguration;
  totalPoints: number[];
  pointsReceived: number;
  isRequiredForCompletion: boolean;
  lecturePageId: number;
  eventSessions: InPersonEventSession[];

  communications?: Communication[],
  communicationsCount?: number,
} & MinimalInPersonEventActivity;

export type NTimelineInPersonEvent = Normalized<TimelineInPersonEvent, 'communications' | 'eventSessions'>;

export type NInPersonEventActivity = Normalized<InPersonEventActivity, 'eventSessions' | 'communications'>;

export interface TimelineInPersonEventNormalized { [id: string]: NTimelineInPersonEvent }
/**
 * Full In-Person Event Activity with all standard activity attributes
 */
export interface InPersonEventActivity extends MinimalInPersonEventActivity {
  // Event-specific attributes
  description?: string;
  checkedInCount: number;
  eventSessions: InPersonEventSession[];

  // Standard activity attributes
  progress: ActivityProgress;
  isTodo: boolean;
  hardDeadline: boolean;
  deadline: string;
  deadlinePassed: boolean;
  totalPoints: number[];
  pointsReceived: number;
  priorLeaderboardRank: number;
  leaderboardPoints: number;
  leaderboardRank: number;
  isRequiredForCompletion: boolean;
  pointsConfiguration: PointsConfiguration;
  createdAt: string;
  released: boolean;
  user: User;

  catalogId: string;
  courseCatalogId: string;
  courseId: string;

  // Course communications
  communications?: Communication[];
  communicationsCount?: number;
}

